import React, { Component,  useState, useEffect  } from 'react';
import './EstruturaTO8.css';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import minirobo from '../../assets/videos/minirobo.mp4';
import interativo2Ativo1 from '../../assets/svgs/interativoAtivo 1.svg';        
import Dt2 from "../../assets/fundos/Dt2.jpg";
import controleremoto from '../../assets/svgs/Controle-01.svg';      
import $, { when } from "jquery";
import { debounce, throttle } from 'lodash';
import seta from '../../assets/svgs/more-white.svg';   

class EstruturaTO8 extends Component {
    componentDidMount() {

        if(window.matchMedia("(max-width: 600px)").matches){
    
        }
        else{
          if($( ".magazinenova" ).mousemove=true){
            $( ".magazinenova" ).mousemove(function( event ) {
             
              $("#TO8desapa").fadeIn();
        
              
            });
          }
          else{
            $("#TO8desapa").fadeOut();
    
          }
    
        }
    
    
    
        $("#TO8dimensao").click(function()
        
        {
          $(".sidebar-wrapper").removeClass("show-sidebar", 500);
          $(".menuuu").addClass("todonone");
          $(".ffechar").addClass("todonone", 500);

          $("#TO8video").prop('muted', false);
          $("#TO8dimensao").addClass("todonone");
          $("#TO8dimensao2").removeClass("todonone");
          $("#TO8desapa2").addClass("todonone");
          $("#TO8video").addClass("pulo");

          $("#TO7dimensao").removeClass("todonone");
          $("#TO7desapa2").removeClass("todonone");
          $("#TO7obra1").removeClass("pulo");
          $("#TO7obra1").removeClass("pulo");
          $("#TO7video").removeClass("pulo");
          $("#TO7local1").removeClass("pulo");
          $("#TO7video").prop('muted', true);

          $("#TO6dimensao").removeClass("todonone");
          $("#TO6desapa2").removeClass("todonone");
          $("#TO6obra1").removeClass("pulo");
          $("#TO6obra1").removeClass("pulo");
          $("#TO6video").removeClass("pulo");
          $("#TO6local1").removeClass("pulo");
          $("#TO6video").prop('muted', true);

          $("#TO5dimensao").removeClass("todonone");
          $("#TO5desapa2").removeClass("todonone");
          $("#TO5obra1").removeClass("pulo");
          $("#TO5obra1").removeClass("pulo");
          $("#TO5video").removeClass("pulo");
          $("#TO5local1").removeClass("pulo");
          $("#TO5video").prop('muted', true);

          $("#TO4dimensao").removeClass("todonone");
          $("#TO4desapa2").removeClass("todonone");
          $("#TO4obra1").removeClass("pulo");
          $("#TO4obra1").removeClass("pulo");
          $("#TO4video").removeClass("pulo");
          $("#TO4local1").removeClass("pulo");
          $("#TO4video").prop('muted', true);

          $("#TO3dimensao").removeClass("todonone");
          $("#TO3desapa2").removeClass("todonone");
          $("#TO3obra1").removeClass("pulo");
          $("#TO3obra1").removeClass("pulo");
          $("#TO3video").removeClass("pulo");
          $("#TO3local1").removeClass("pulo");
          $("#TO3video").prop('muted', true);

          $("#TO2dimensao").removeClass("todonone");
          $("#TO2desapa2").removeClass("todonone");
          $("#TO2obra1").removeClass("pulo");
          $("#TO2obra1").removeClass("pulo");
          $("#TO2video").removeClass("pulo");
          $("#TO2local1").removeClass("pulo");
          $("#TO2video").prop('muted', true);

          $("#dimensao").removeClass("todonone");
          $("#desapa2").removeClass("todonone");
          $("#obra1").removeClass("pulo");
          $("#obra1").removeClass("pulo");
          $("#video").removeClass("pulo");
          $("#local1").removeClass("pulo");
          $("#video").prop('muted', true);
      
    
        }
        );
        $("#TO8dimensao2").click(function()
        
        {
          $(".menuuu").removeClass("todonone");
          $("#TO8video").prop('muted', true);
          $("#TO8dimensao2").addClass("todonone");
          $("#TO8dimensao").removeClass("todonone");
          $("#TO8desapa2").removeClass("todonone");
          $("#TO8obra1").removeClass("pulo");
          $("#TO8obra1").removeClass("pulo");
          $("#TO8video").removeClass("pulo");
          $("#TO8local1").removeClass("pulo");
          
        }
        );
    
    
        $("#TO8magazinenova").click(function(){
          $("#TO8desapa").delay('slow').fadeIn();
            
        
    
          setTimeout(
            function() 
            {
    
              
              var desaparecendo = 'todonone';
            
              $("#TO8desapa").fadeOut();
            }, 30000);
    
        });
    
        (function () {
    
          $("#TO8botomenu").click(function () {
            $( this ).slideUp().fadeOut(10000);
            $("#TO8hold1 ").addClass("cc");
            $("#TO8botoobras ").addClass("cc");
            $("#TO8hold3 ").addClass("cc");
            $("#TO8hold4 ").addClass("cc");
            $("#TO8hold5 ").addClass("cc");
            $("#TO8hold1 ").removeClass("transiopaca");
            $("#TO8botoobras ").removeClass("transiopaca");
            $("#TO8hold3 ").removeClass("transiopaca");
            $("#TO8hold4 ").removeClass("transiopaca");
            $("#TO8hold5 ").removeClass("transiopaca");
            setTimeout(function(){
              setTimeout(function(){
                $("#TO8hold5 ").addClass("transiopaca");
                setTimeout(function(){
                  $("#TO8hold4 ").addClass("transiopaca");
                  setTimeout(function(){
                    $("#TO8hold3 ").addClass("transiopaca");
                    setTimeout(function(){
                      $("#TO8botoobras ").addClass("transiopaca");
                      $("#TO8hold1 ").addClass("transiopaca");
                      setTimeout(function(){
                        $("#TO8hold1 ").removeClass("cc");
                        $("#TO8botoobras ").removeClass("cc");
                        $("#TO8hold3 ").removeClass("cc");
                        $("#TO8hold4 ").removeClass("cc");
                        $("#TO8hold5 ").removeClass("cc");
                        $("#TO8botomenu").slideDown();
                      },1000);
                    },1000);
    
    
                  },1000);
    
    
                },1000);
    
              },1000);
    
    
    
    
    
    
    
              }, 3000);
            
          });
    
          var qua = $('.resposta');
          var $target = $('.gatilhoObra'),
            animationClass = 'respostaGatilho',
            animationClass2 = 'respostaGatilho2',
            offset = $(window).height() * 1 / 10;
    
    
    
          function animeScroll() {
            $("#TO8desapa").fadeOut();
            
        
    
            setTimeout(
              function() 
              {
                var desaparecendo = 'todonone';
              
                $("#TO8desapa").fadeIn();
              }, 2000);
    
    
            var documentTop = $(document).scrollTop();
    
            $target.each(function (index) {
    
              var itemTop = $(this).offset().top;
    
              if (documentTop > itemTop - offset) {
                $("#TO8botoobras").addClass(animationClass2);
                
              }
              else{
                $("#TO8boto" + index).removeClass(animationClass);
                  
              }
    
              if (documentTop > itemTop - offset) {
                $("#TO8boto" + index).addClass(animationClass);
                
                if (documentTop > itemTop * 2 - offset * 2) {
                  $("#TO8boto" + index).removeClass(animationClass);
                  
                }
                if (documentTop > itemTop){
                  $("#TO8boto" + index).removeClass(animationClass);
                  
                }
              }
            }
    
            
    
            );
          }
    
         
    
          $(document).scroll(debounce(function () {
            animeScroll();
          }, 200));
        })();
    
    
        $('.bolinhas a[href^="#TO8"]').on('click', function (e) {
          e.preventDefault();
          var id = $(this).attr('href'),
            targetOffset = $(id).offset().top;
    
          $('html, body').animate({
            scrollTop: targetOffset - 0
          }, 500);
        });
    
        $('.grandeMenu a[href^="#TO8"]').on('click', function (e) {
          e.preventDefault();
          var id = $(this).attr('href'),
            targetOffset = $(id).offset().top;
    
          $('html, body').animate({
            scrollTop: targetOffset - 0
          }, 500);
        });
      }
    render() {
        return (
            <div id="TO8obra1" className="displayTO8 gatilhoObra"> {this.props.children}
                <div id="TO8local1"className="videolocalTO8" style={{backgroundImage: 'url(' + {Dt2} +')'}}>
                <div class="sidebar-wrapper">
                        <div class="sidebar">
                            <h3> 2019 - 2020   </h3>
                            <h2 class="sidebar-titulo">BAILE DE ROBÔS  </h2>
                            <p class="descricao">Instalação interativa  via comando de celulares. Um conjunto de mini robôs movimenta-se como um enxame. Apresentam aspectos luminosos e manifestações sonoras a partir do próprio movimento dos robôs </p>
                            <a className="botaops repon"  href="https://bailederobos.netlify.app/">obra interativa</a>
                        </div>
                        <div class="menuuu" id="menuuu"><i class="fa fa-bars fa-2x">
                        <img className="ring button" src={seta} alt=""/>
                        
                            
                            
                            
                            
                            </i></div>
                    </div>
 
 
 
 
                    <div className="tampavideoTO8">
                    </div>
                    <div className="ffechar todonone">
                       <i> FECHAR </i>
                    </div>
                    <div className="videoTO8" >
                        <video controlsList = "nofullscreen nodownload noremoteplayback" poster="a" id="TO8video" playsInline autoPlay muted loop>
                            <source src={minirobo} type="video/mp4">
                            </source>
                        </video>
                    </div>
                    <div className="sobrepo1TO8"></div>
                    <div className="sobrepo2TO8"></div>
                    <div className="sobrepo3TO8"></div>
                </div>
                <div id="TO8desapa" className="magazineTO8">

                </div>
                <div className="magazinenova" id="TO8magazinenova">
                    <div id="TO8dimensao"className="controleremoto">
                        <img src={controleremoto} alt=""/>
                    </div>
                    <div id="TO8dimensao2"className="controleremoto2 todonone">
                    <img src={controleremoto} alt=""/>
                        
                </div>
                </div>
            </div>
        );
    }
}
 
export default EstruturaTO8  ;